import { ifFeature } from '@bamboohr/utils/lib/feature';
import { makeStyles } from '~styles';

export const signatureFont = '4rem "Ephesis"';

export const useStyles = makeStyles()(({ palette, spacing, constructs }) => {
	return {
		clear: {
			position: 'absolute',
			right: spacing(3),
			top: spacing(2),
		},
		container: {
			alignItems: 'flex-end',
			display: 'flex',
			height: '100%',
			paddingTop: `${spacing(6)}`,
			boxSizing: 'border-box',
		},
		input: {
			background: 'none',
			border: 'none',
			font: signatureFont,
			height: '100%',
			padding: `${spacing(4)} ${spacing(3)} 0px ${spacing(3)}`,
			textIndent: '29px',
			width: '100%',
		},
		placeholder: {
			bottom: 0,
			color: ifFeature('encore', constructs.text.neutral.xStrong, palette.gray[700]),
			lineHeight: spacing(3),
			padding: `${spacing(5)} 55px`,
			pointerEvents: 'none', // Prevent element from being interactive
			position: 'absolute',
		},
		root: {
			height: '100%',
			borderRadius: spacing(1),
			'&:focus-within': {
				outline: `2px solid ${palette.primary.lightest}`,
			},
		},
	};
});
